var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3975_13718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 0.45L12.29 2.56C12.1 2.84 11.79 3.01 11.46 3.01H1C0.45 3.01 0 3.46 0 4.01V15.01C0 15.56 0.45 16.01 1 16.01H21C21.55 16.01 22 15.56 22 15.01V1C22 0.45 21.55 0 21 0H14.54C14.21 0 13.89 0.17 13.71 0.45H13.7Z",
    fill: "#FFB600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3975_13718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.65af857fdc0c0bc61a4f958fc765026c.svg";
export { ForwardRef as ReactComponent };